import styled from 'styled-components/native';

export const ScrollView = styled.ScrollView`
  width: 100%;
`;
